// TODO: Maybe we should make this a 'server-only' file?

const defaultRequestOptions: RequestInit = {
  headers: {
    'Content-Type': 'application/json',
  },
  method: 'POST',
};

type Response<T> = { success: true; value: T } | { success: false; error: Error };

// NOTE: Switch this to use exceptions pattern rather than results objects
// biome-ignore lint/complexity/noStaticOnlyClass: <We need just these functions>
export class GetData {
  static async getData<T>(
    query: string,
    params: object,
    endpoint: string,
    nextRequestOptions: Pick<RequestInit, 'cache' | 'next'> = {},
    requestOptions: Omit<RequestInit, 'cache' | 'next'> = defaultRequestOptions,
  ): Promise<Response<T>> {
    try {
      const response = await fetch(endpoint, {
        body: JSON.stringify({
          query,
          variables: params,
        }),
        ...nextRequestOptions,
        ...requestOptions,
      });

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const json = await response.json();

      if (json.errors) {
        return { error: json.errors, success: false };
      }

      if (!json.data) {
        return { error: { message: 'No Data returned from GraphQL Query', name: 'No Data' }, success: false };
      }

      return { success: true, value: json.data };
    } catch (error) {
      return { error: error as Error, success: false };
    }
  }

  static async content<T>(
    query: string,
    params: object = {},
    requestOptions: Pick<RequestInit, 'cache' | 'next'> = defaultRequestOptions,
  ): Promise<Response<T>> {
    return await GetData.getData<T>(
      query,
      params,
      `${process.env.WORDPRESS_URL}${process.env.WORDPRESS_GQL_PATH}`!,
      requestOptions,
    );
  }

  static async backend<T>(
    query: string,
    params: object = {},
    requestOptions: Pick<RequestInit, 'cache' | 'next'> = defaultRequestOptions,
  ): Promise<Response<T>> {
    return await GetData.getData<T>(query, params, process.env.REPLATFORM_GQL_URL!, requestOptions);
  }

  static async redVentures<T>(
    query: string,
    params: object,
    requestOptions: Pick<RequestInit, 'cache' | 'next'> = defaultRequestOptions,
  ): Promise<Response<T>> {
    return await GetData.getData<T>(query, params, process.env.RED_VENTURES_GQL_URL!, requestOptions);
  }
}
